import { useParams } from "react-router-dom";

export const useScheduleEditPageParams = () => {
  const { siteSlug = "", scheduleSlug = "" } = useParams();

  return { siteSlug, scheduleSlug };
};
